<template>
  <div class="common-table">
    <el-table ref="tableRef" :data.sync="tableData" size="small" style="width: 100%" :height="tableHeight" max-height="800px" @selection-change="selectionChange" @cell-mouse-enter="cellMouseEnter" @cell-mouse-leave="cellMouseLeave" @cell-dblclick="cellDblclick">
      <slot />
    </el-table>
    <el-pagination class="fixed-below" background :current-page.sync="paginationParams.current" :page-sizes="paginationParams.sizes" :page-size="paginationParams.size" layout="total, prev, pager, next, sizes" :total="paginationParams.total" @size-change="handleSizeChange"
      @current-change="handleCurrentChange" />
  </div>
</template>

<script>
export default {
  props: {
    autoHeight: {
      type: Boolean,
      default: false,
    },
    tableQuery: {
      type: Object,
      default: () => { },
    },
    queryFunction: {
      type: Function,
      default: null,
    },
    dealData: { // 处理返回的数据
      type: Function,
      default: null,
    },
    cellMouseEnter: {
      type: Function,
      default: () => { },
    },
    cellMouseLeave: {
      type: Function,
      default: () => { },
    },
    cellDblclick: {
      type: Function,
      default: () => { },
    },
  },
  data() {
    return {
      tableData: [],
      tableHeight: null,
      paginationParams: {
        current: 1,
        size: 10,
        sizes: [5, 10, 20, 50, 100],
        total: 0,
      },
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.autoHeight && this.getHeight();
    });
    this.getTableList();
  },
  methods: {
    // 动态计算高度
    getHeight() {
      const el = this.$refs['tableRef'].$el;
      const offsetTop = el.offsetTop;
      const wHeight = window.innerHeight;
      const tableHeight = wHeight - offsetTop - 290;
      this.tableHeight = tableHeight <= 500 ? 500 : tableHeight;
    },
    searchAndReset() {
      this.paginationParams.current = 1;
      this.getTableList();
    },
    getData() {
      return this.tableData;
    },
    getTableList() {
      const params = Object.assign(
        {
          current: this.paginationParams.current,
          limit: this.paginationParams.size,
        },
        this.tableQuery
      );
      this.queryFunction(params).then(res => {
        this.tableData = this.dealData ? this.dealData(res.data) : res.data;
        this.paginationParams.current = res.current;
        this.paginationParams.size = res.limit;
        this.paginationParams.total = res.total;
      });
    },
    handleSizeChange(value) {
      // this.$emit('size-change', value)
      this.paginationParams.size = value;
      this.getTableList();
    },
    handleCurrentChange(value) {
      // this.$emit('current-change', value)
      this.paginationParams.current = value;
      this.getTableList();
    },
    // 选择项发生变化时会触发该事件
    selectionChange(selection) {
      this.$emit('selection-change', selection);
    },
  },
};
</script>

<style lang="less" scoped>
.el-pagination {
  position: relative;
  bottom: 0;
  left: 0;
  margin-top: 30px;
}
</style>
